export default __webpack_public_path__ + "static/media/Lip_5_M.fde1a891.svg";